import { useTranslation } from 'react-i18next';
import { Settings as SettingsIcon, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import { Tabs, ProgressBar, IconButton } from '@hump/ui';
import { useReaderStore, type DisplayMode } from '../../stores/reader';
import { TableOfContents } from './TableOfContents';
import { DocSearch } from './DocSearch';
import { AnnotationList } from './AnnotationList';

export function ReaderToolbar() {
  const { t } = useTranslation();
  const { docIndex, displayMode, setDisplayMode, settingsOpen, setSettingsOpen } = useReaderStore();

  const modeTabs = [
    { id: 'bilingual', label: t('reader.modeBilingual') },
    { id: 'mixed', label: t('reader.modeMixed') },
    { id: 'original', label: t('reader.modeOriginal') },
    { id: 'translation', label: t('reader.modeTranslation') },
  ];

  return (
    <div className="sticky top-0 z-20 bg-white dark:bg-warm-dark border-b border-border-warm dark:border-border-warm-dark px-4 py-2">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <Link to="/shelf">
            <IconButton size="sm" aria-label="返回书架">
              <ArrowLeft className="w-4 h-4" />
            </IconButton>
          </Link>
          <div className="min-w-0 flex-1">
            <h1 className="text-sm font-medium text-charcoal dark:text-charcoal-light truncate">
              {docIndex?.meta.title ?? ''}
            </h1>
            <div className="flex items-center gap-2 mt-0.5">
              <ProgressBar value={(docIndex?.meta.progress ?? 0) * 100} className="w-24 h-1" />
              <span className="text-xs text-charcoal/50 dark:text-charcoal-light/50">
                {Math.round((docIndex?.meta.progress ?? 0) * 100)}%
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Tabs
            tabs={modeTabs}
            activeId={displayMode}
            onChange={(id) => setDisplayMode(id as DisplayMode)}
          />
          <TableOfContents />
          <DocSearch docId={docIndex?.id ?? ''} />
          <AnnotationList />
          <IconButton
            size="sm"
            onClick={() => setSettingsOpen(!settingsOpen)}
            aria-label={t('reader.settings')}
          >
            <SettingsIcon className="w-4 h-4" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
